import { z } from 'zod';

export const formFieldSchema = z.object({
  id: z.string(),
  type: z.enum(['text', 'email', 'tel', 'textarea', 'select', 'checkbox', 'radio']),
  label: z.string(),
  placeholder: z.string().optional(),
  required: z.boolean().default(false),
  options: z.array(z.object({ label: z.string(), value: z.string() })).optional(),
});

export type FormField = z.infer<typeof formFieldSchema>;

export const formSchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  fields: z.array(formFieldSchema),
  submit_label: z.string().default('ارسال'),
  success_message: z.string().default('پیام شما با موفقیت ارسال شد.'),
  email_to: z.array(z.string().email()).default([]),
  is_active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type Form = z.infer<typeof formSchema>;

export const formSubmissionSchema = z.object({
  id: z.string().uuid(),
  form_id: z.string().uuid(),
  site_id: z.string().uuid(),
  data: z.record(z.string()),
  ip_address: z.string().optional(),
  is_read: z.boolean().default(false),
  created_at: z.string().datetime(),
});

export type FormSubmission = z.infer<typeof formSubmissionSchema>;
